module.exports = __webpack_public_path__ + "img/story003.ed6475e7.webp";